import { render, staticRenderFns } from "./performance-scoring-business-form.vue?vue&type=template&id=4d1b5cb3"
import script from "./performance-scoring-business-form.vue?vue&type=script&lang=js"
export * from "./performance-scoring-business-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports